import React from 'react'

const Footer = () => {
  return (
    <div className='footer-container'>
    <div class="footer">
        <div class="box_footer_one">
            <h2>AMERICAN SAS</h2>

            <p> Lorem ipsum dolor sit amet consectetur adipisicing elit. <br></br>Tempore dolorem obcaecati illo dolor maxime? <br></br>Consequatur alias quo neque labore deserunt earum. </p>

        </div>
        <div class="box_footer_middle">
            <a href="">Acerca de</a>
            <a href="">Trabajos</a>

        </div>
        <div class="box_footer_two">
            <a href="">Instagram</a>
            <a href="#">Mail</a>
            <a href="#">Ubicación</a>
        </div>
        </div>
    <div class="linea">   
    </div>
    <p className='code'>CodeFICA DEV © 2023</p>
    </div>

  )
}

export default Footer